import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import { TEMPLATE_SKELETON_LINE } from './templateSkeletonCommon'

const CARD_BORDER = '#e8edf2'
const PREVIEW_WELL_BG = '#f0f8fd'

function TemplatePreviewQuestionCardSkeleton() {
  return (
    <Box
      sx={{
        bgcolor: '#ffffff',
        border: `1px solid ${CARD_BORDER}`,
        borderRadius: '14px',
        p: '20px',
      }}
    >
      <Stack direction="row" spacing={1.25} sx={{ mb: 1.5 }}>
        <Skeleton variant="rounded" width={36} height={22} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="rounded" width={120} height={24} sx={{ borderRadius: '999px' }} />
      </Stack>
      <Skeleton variant="rounded" width="85%" height={22} sx={{ ...TEMPLATE_SKELETON_LINE, mb: 1.5 }} />
      <Box
        sx={{
          bgcolor: PREVIEW_WELL_BG,
          border: `1px solid ${CARD_BORDER}`,
          borderRadius: '10px',
          p: 1.625,
        }}
      >
        <Skeleton variant="rounded" width="70%" height={18} sx={TEMPLATE_SKELETON_LINE} />
        <Skeleton variant="rounded" width="100%" height={40} sx={{ ...TEMPLATE_SKELETON_LINE, mt: 1.5 }} />
      </Box>
    </Box>
  )
}

export function TemplatePreviewQuestionsSkeleton() {
  return (
    <Stack
      spacing={1.5}
      data-testid="instrument-template-preview-questions-skeleton"
      aria-busy
      aria-label="Loading template questions"
    >
      <TemplatePreviewQuestionCardSkeleton />
      <TemplatePreviewQuestionCardSkeleton />
      <TemplatePreviewQuestionCardSkeleton />
    </Stack>
  )
}
